import {
    ATTEMPT_UPLOAD_AVATAR,
    EDIT_ATHLETE
} from 'shared_redux/actions';

export const upload = (athleteId, file) => ({ type: ATTEMPT_UPLOAD_AVATAR, athleteId, file });

export const editAthlete = (athleteId) => ({ type: EDIT_ATHLETE, athleteId });
